import EvidencePanel from './EvidencePanel';

export default EvidencePanel;

export type { IEvidencePanelProps } from './EvidencePanel';
